import * as service from './service'

export default {
  namespace: 'honourKnightHome',
  state: {
    demoData: {}
  },
  effects: {
    * getHonourHome ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getHonourHome, payload)
        return res.data.data
      } catch (e) {}
      // yield put({
      //   type: 'save',
      //   payload: {
      //     honourHomeData : res.data.data,
      //   },
      // })
    },
    * askForLeave ({ payload }, { call, put }) {
      const res = yield call(service.askForLeave, payload)
      return res
    },
    * honourJoin ({ payload }, { call, put }) {
      const res = yield call(service.honourJoin, payload)
      return res
    },
    * honourQuit ({ payload }, { call, put }) {
      const res = yield call(service.honourQuit, payload)
      return res
    },
    * getPropTips ({ payload }, { call, put }) {
      const res = yield call(service.getPropTips, payload)
      return res
    }
  },
  reducers: {
    save (state: any, { payload }: any) {
      return { ...state, ...payload }
    }
  }
}
